import React from 'react';
import Grid from '@mui/material/Grid';
//import { useParams, useRouteMatch } from "react-router-dom";

export default function Loading() {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ maxHeight: '100px' }}
      >
        <img src={process.env.PUBLIC_URL + '/assets/dots_circle.gif'} alt="Loadinng .." height="100px"/>
      </Grid>
    );
}
